var render = function render(){var _vm=this,_c=_vm._self._c;return _c('categoryLayout',{attrs:{"template-type":"trash"}},[_c('Categories',{attrs:{"mode":"trash","categories":_vm.categories}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }